import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const isSupabaseConfigured = Boolean(
  supabaseUrl &&
  supabaseAnonKey &&
  supabaseUrl.trim().length > 0 &&
  supabaseAnonKey.trim().length > 0 &&
  !supabaseUrl.includes('placeholder-project') &&
  !supabaseAnonKey.includes('placeholder-anon-key')
);

// Single Supabase client instance using only publishable browser-safe anon key
export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : createClient('https://gxylwokcqxmjyvqxxgup.supabase.co', 'placeholder-key', {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
      },
    });

/**
 * Small internal connection verification helper
 * Returns { success: boolean, message: string } without exposing secrets
 */
export async function checkSupabaseConnection() {
  if (!isSupabaseConfigured) {
    return {
      connected: false,
      error: 'Supabase URL or Anon Key is missing or set to placeholder in .env',
    };
  }

  try {
    const { error } = await supabase.from('site_settings').select('count', { count: 'exact', head: true });
    if (error && error.code !== 'PGRST116') {
      // If table doesn't exist yet or connection problem
      return {
        connected: false,
        error: error.message || 'Database connection error',
        code: error.code,
      };
    }
    return {
      connected: true,
      url: supabaseUrl,
    };
  } catch (err) {
    return {
      connected: false,
      error: err.message || 'Network connection failed',
    };
  }
}

export default supabase;
